export default "__VITE_ASSET__UeWIfb_5__"